enum EScoringGroup {
  All = -1,
  Manual = -2,
  Auto = -3,
  Default = 1,
}

export default EScoringGroup;
